import qs from 'query-string';
import { apiConfig } from '../api-config';

export interface GetAgentParams {
  tokenKey: string;
  document: string;
}

export const getAgent = async (params: GetAgentParams) => {
  const query = qs.stringify(params);
  return apiConfig
    .get(`api/Agent/get-agent-by-document?${query}`)
    .then((resp) => resp.data)
    .catch((err) => ({ hasErrors: true, err }));
};
